import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className="container pb-3">
        <hr />
        <div>
          <p className="footer-text mt-2">© 2021 - 2022 Ydeezy, Inc.</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
